import { executeRequest, Request } from '@jfs/network'
import { getConsentsMock } from '../mocks/getConsents'
import { getNetworkResponseError, isStatusOK } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApiScheduled } from './sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data) && data?.data?.consentData?.consents) {
    return data?.data?.consentData?.consents
  } else {
    throw getNetworkResponseError(data?.data)
  }
}
const IS_CONSENT_MOCK = true
export const getConsents = (tokens: any) => {
  if (IS_CONSENT_MOCK) {
    console.log(
      '(getConsentsMock as any).default',
      (getConsentsMock as any).default?.[0]?.response?.consentData?.consents,
    )
    return new Promise((res) => res((getConsentsMock as any).default?.[0]?.response?.consentData?.consents))
  }
  const request: Request<{}> = {
    apiPath: APIEndPoints.consent,
    method: 'POST',
    config: apiConfig(tokens),
    body: getConsentsRequest(),
  }
  sendEventApiScheduled(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApiScheduled(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApiScheduled(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      return responseParser(err)
    })
}

const getConsentsRequest = () => {
  return {
    readConsentText: {
      readConsentRequest: {
        salesChannel: {
          id: 'Z005',
        },
      },
    },
  }
}
